import { useEffect, useState } from 'react';
import EmptyCart from './EmptyCart';
import GreetingModal from './GreetingModal';
import { useCart } from '../../hooks/useCart';
import { useNavigate } from 'react-router-dom';

function CartSuccess() {
	const navigate = useNavigate();
	const [modalOpen, setOpenModal] = useState(false);
	const { emptyCart } = useCart();

	useEffect(() => {
		sendMessage();
		setOpenModal(true);
		setTimeout(() => {
			closeModal();
		}, 5000);
	}, []);

	const sendMessage = () => {
		const channel = new BroadcastChannel('laykaWorker');
		channel.postMessage({ paymentSuccessful: true });
	};

	const closeModal = () => {
		setOpenModal(false);
		emptyCart();
		navigate('/');
	};
	return (
		<div className=" w-full  flex flex-col bg-[#F1F1FE]">
			<EmptyCart />
			<GreetingModal modalIsOpen={modalOpen} closeModal={closeModal} />
		</div>
	);
}

export default CartSuccess;
